import React from 'react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-black pt-16 pb-8" data-id="element-50">
      <div className="max-w-7xl mx-auto px-6" data-id="element-51">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16" data-id="element-52">
          <div className="col-span-2 md:col-span-1" data-id="element-53">
            <div className="text-2xl font-black tracking-tighter text-white mb-4" data-id="element-54">
              TATAN
            </div>
            <p className="text-sm text-gray-500 max-w-xs" data-id="element-55">
              The world's most advanced AI tattoo designer and AR try-on
              experience.
            </p>
          </div>

          <div data-id="element-56">
            <h4 className="font-bold mb-4" data-id="element-57">Product</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-58">
              <li data-id="element-59">
                <a href="#features" className="hover:text-white transition-colors" data-id="element-60">
                  Features
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="hover:text-white transition-colors" data-id="element-62">
                  Gallery
                </a>
              </li>
              <li data-id="element-63">
                <a href="#" className="hover:text-white transition-colors" data-id="element-64">
                  Download App
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-65">
            <h4 className="font-bold mb-4" data-id="element-66">Company</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-67">
              <li data-id="element-68">
                <a href="#" className="hover:text-white transition-colors" data-id="element-69">
                  About Us
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-white transition-colors" data-id="element-71">
                  Careers
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="hover:text-white transition-colors" data-id="element-73">
                  Contact
                </a>
              </li>
              <li data-id="element-74">
                <a href="#" className="hover:text-white transition-colors" data-id="element-75">
                  Press Kit
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-76">
            <h4 className="font-bold mb-4" data-id="element-77">Legal</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-78">
              <li data-id="element-79">
                <a href="https://go.pixo.co/tatan-privacy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-80">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-81">
                <a href="https://go.pixo.co/tatan-terms" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-82">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="hover:text-white transition-colors" data-id="element-84">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-85">
          <p className="text-sm text-gray-600" data-id="element-86">
            © {new Date().getFullYear()} TATAN Inc. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-600" data-id="element-87">
            <a href="#" className="hover:text-white transition-colors" data-id="element-88">
              Twitter
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-89">
              Instagram
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-90">
              TikTok
            </a>
          </div>
        </div>
      </div>
    </footer>;
}